import React from 'react'
import './MiniTag.css'

export default function MiniTag({title}) {
  return (
    <div className='miniTag'>{title}</div>
  )
}
